(function() {
  'use strict';

  // Only run on /pages/get-app
  if (!window.location.pathname.startsWith('/pages/get-app')) return;

  var STORAGE_KEY = 'cd_pwa_views';
  var VIEWS_REQUIRED = 2;
  var deferredPrompt = null;

  // Track page views
  var views = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10) + 1;
  localStorage.setItem(STORAGE_KEY, views.toString());

  // Capture the beforeinstallprompt event
  window.addEventListener('beforeinstallprompt', function(e) {
    e.preventDefault();
    deferredPrompt = e;

    // Show install banner after required views
    if (views >= VIEWS_REQUIRED) {
      showInstallBanner();
    }
  });

  function showInstallBanner() {
    // Don't show if already installed (standalone mode)
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (window.navigator.standalone === true) return;

    // Create banner
    var banner = document.createElement('div');
    banner.id = 'pwa-install-banner';
    banner.innerHTML =
      '<div class="pwa-install-content">' +
        '<img src="https://cdn.shopify.com/s/files/1/0763/8260/1538/files/Chrome_District_Logo_Design_192x192.png?v=1757091480" ' +
          'alt="Chrome District" class="pwa-install-icon">' +
        '<div class="pwa-install-text">' +
          '<strong>Install Chrome District</strong>' +
          '<span>Quick access from your home screen</span>' +
        '</div>' +
        '<button class="pwa-install-btn" id="pwa-install-accept">Install</button>' +
        '<button class="pwa-install-dismiss" id="pwa-install-dismiss" aria-label="Dismiss">&times;</button>' +
      '</div>';

    document.body.appendChild(banner);

    // Animate in
    requestAnimationFrame(function() {
      banner.classList.add('pwa-install-visible');
    });

    // Install button
    document.getElementById('pwa-install-accept').addEventListener('click', function() {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(function(result) {
          deferredPrompt = null;
          removeBanner();
        });
      }
    });

    // Dismiss button
    document.getElementById('pwa-install-dismiss').addEventListener('click', function() {
      removeBanner();
      // Don't show again this session
      sessionStorage.setItem('cd_pwa_dismissed', '1');
    });
  }

  function removeBanner() {
    var banner = document.getElementById('pwa-install-banner');
    if (banner) {
      banner.classList.remove('pwa-install-visible');
      setTimeout(function() { banner.remove(); }, 300);
    }
  }

  // Don't show if dismissed this session
  if (sessionStorage.getItem('cd_pwa_dismissed')) return;
})();

